import React from "react"
import SectionsGallery from "../../LiveEditor/Console/PagesEditor/SectionsGallery"


const SectionsGalleryCp = () => (
	<SectionsGallery open />
)

export default SectionsGalleryCp
